import { useNavigate } from "react-router-dom";
import { CalendarDays, MessageCircle, Phone, UserRound } from "lucide-react";
import { StatusBadge, PriorityBadge, fmtDate, waLink } from "@/components/ticketMeta";

export const TicketCard = ({ t, index = 0 }) => {
  const nav = useNavigate();
  return (
    <div
      data-testid={`ticket-card-${t.id}`}
      onClick={() => nav(`/tichete/${t.id}`)}
      style={{ animationDelay: `${Math.min(index, 12) * 40}ms`, animationFillMode: "both" }}
      className="group cursor-pointer rounded-xl border bg-card p-4 sm:p-5 transition-[border-color,transform,box-shadow] duration-200 hover:-translate-y-0.5 hover:border-primary/50 hover:shadow-lg hover:shadow-primary/5 animate-in fade-in slide-in-from-bottom-2"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="flex items-center gap-2 text-xs">
            <span className="font-mono text-muted-foreground" data-testid={`ticket-code-${t.id}`}>{t.code}</span>
            {t.source === "whatsapp" && <MessageCircle className="h-3.5 w-3.5 text-green-500" />}
          </div>
          <h3 className="mt-1 truncate text-lg font-semibold tracking-tight">{t.client_name}</h3>
          {t.equipment && <p className="truncate text-sm text-muted-foreground">{t.equipment}</p>}
        </div>
        <div className="flex shrink-0 flex-col items-end gap-1.5">
          <StatusBadge status={t.status} />
          <PriorityBadge priority={t.priority} />
        </div>
      </div>
      <p className="mt-3 line-clamp-2 text-sm text-foreground/85">{t.description}</p>
      <div className="mt-4 flex items-center justify-between gap-2 border-t pt-3 text-xs text-muted-foreground">
        <div className="flex min-w-0 items-center gap-3">
          <span className="flex shrink-0 items-center gap-1">
            <CalendarDays className="h-3.5 w-3.5" />
            {fmtDate(t.scheduled_date || t.created_at)}
          </span>
          <span className="flex min-w-0 items-center gap-1">
            <UserRound className="h-3.5 w-3.5 shrink-0" />
            <span className="truncate">{t.technician_name || "Nealocat"}</span>
          </span>
        </div>
        {t.phone && (
          <div className="flex shrink-0 gap-1" onClick={(e) => e.stopPropagation()}>
            <a href={`tel:${t.phone}`} data-testid={`ticket-call-${t.id}`} className="rounded-lg p-2 transition-colors hover:bg-accent hover:text-foreground" aria-label="Sună">
              <Phone className="h-4 w-4" />
            </a>
            <a href={waLink(t.phone)} target="_blank" rel="noreferrer" data-testid={`ticket-wa-${t.id}`} className="rounded-lg p-2 text-green-600 transition-colors hover:bg-green-500/10 dark:text-green-400" aria-label="WhatsApp">
              <MessageCircle className="h-4 w-4" />
            </a>
          </div>
        )}
      </div>
    </div>
  );
};
